export default __webpack_public_path__ + "static/media/Joe.35669404.jpg";